import React from 'react';

import { FormControl, FormControlLabel, Checkbox, Box } from '@mui/material';

const CheckBoxField = ({
  sx,
  fullWidth,
  label,
  value,
  onChange,
  labelStyle,
}) => {
  return (
    <FormControl
      fullWidth={fullWidth}
      sx={sx}>
      <FormControlLabel
        label={
          <Box
            component='div'
            sx={labelStyle}>
            {label}
          </Box>
        }
        control={
          <Checkbox
            checked={value}
            onChange={onChange}
          />
        }
      />
    </FormControl>
  );
};

export default CheckBoxField;
